module.exports = __webpack_public_path__ + "img/f1-en.a7cd7824.jpeg";